import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="bg-white border-t border-gray-200 py-16 mt-auto">

      <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 md:grid-cols-4 gap-12">

        <div className="col-span-1 md:col-span-1">
          <span className="text-2xl font-black text-blue-700 tracking-tighter">
            TRANZITIO<span className="text-rose-500">.</span>
          </span>
          <p className="text-gray-500 text-sm mt-4 leading-relaxed">
            Platforma creata din pasiune pentru simplitate. Oferim un mediu curat si sigur pentru tranzactiile tale zilnice.
          </p>
        </div>

        <div>
          <h4 className="font-bold text-gray-900 mb-6 uppercase tracking-wider text-sm">
            Informatii
          </h4>
          <ul className="text-gray-600 text-sm space-y-3 font-medium">
            <li>
              <Link to="/cum-functioneaza" className="hover:text-blue-600 transition">
                Cum functioneaza
              </Link>
            </li>
            <li>
              <Link to="/reguli" className="hover:text-blue-600 transition">
                Reguli de publicare
              </Link>
            </li>
            <li>
              <Link to="/contact" className="hover:text-blue-600 transition">
                Contacteaza-ne
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-bold text-gray-900 mb-6 uppercase tracking-wider text-sm">
            Categorii de top
          </h4>
          <ul className="text-gray-600 text-sm space-y-3 font-medium">
            <li>
              <Link to="/cautare?cat=Auto,%20moto%20si%20ambarcatiuni" className="hover:text-blue-600 transition">
                Auto & Moto
              </Link>
            </li>
            <li>
              <Link to="/cautare?cat=Imobiliare" className="hover:text-blue-600 transition">
                Imobiliare
              </Link>
            </li>
            <li>
              <Link to="/cautare?cat=Electronice%20si%20electrocasnice" className="hover:text-blue-600 transition">
                Electronice & IT
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-bold text-gray-900 mb-6 uppercase tracking-wider text-sm">
            Proiect Universitar
          </h4>
          <p className="text-sm text-gray-500 font-medium">
            Acest site web a fost dezvoltat integral folosind stack-ul MERN pentru lucrarea de licenta.
          </p>
        </div>

      </div>

      <div className="max-w-7xl mx-auto px-4 border-t border-gray-100 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center text-gray-400 text-sm font-medium">
        <p>2026 TRANZITIO. Toate drepturile rezervate.</p>
        <div className="flex gap-4 mt-4 md:mt-0">
          <Link to="/termeni" className="hover:text-blue-600 transition">
            Termeni
          </Link>
          <Link to="/confidentialitate" className="hover:text-blue-600 transition">
            Confidentialitate
          </Link>
        </div>
      </div>

    </footer>
  );
}

export default Footer;